export default __webpack_public_path__ + "media/hero.19b95f1994a9e43cb051684989ca9572.svg";